module.exports = __webpack_public_path__ + "static/media/dashboard-icon-engagement.8c312450.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard-icon-engagement.svg
// module id = 1879
// module chunks = 0